import { IconMoneybag, IconBookFilled, IconUsersGroup, IconClock } from "@tabler/icons-react"
import { icon } from "../functions/icons"
import { Badge } from "../atoms/badges"
import { IconText } from "./courseComp"
import { Trend } from "../atoms/trend"
import { SkeletonCourseTableRow } from "../atoms/skeletonloaders"
import { IconAtom } from "../atoms/iconAtom"
import { HorizontalLayout, VerticalLayout } from "./layout"
import { StandardComp } from "../atoms/standardComp"
import { margin, padding } from "polished"
import { TitleAction } from "../molecule/TitleAction"
import { DropdownButton, StandardButton } from "../atoms/buttons"
import { HeaderTitle } from "../molecule/headerTitle"
import { useContext, useEffect, useState } from "react"
import { formatDistanceToNow } from 'date-fns';
import { nl } from 'date-fns/locale';
import { PageContext, UserContext } from "../App";
import { CourseStatusLabel, CourseTableRow } from "./courseTableComp"

export function StepTableComp({ steps = [], headers= [] }) {

    const stepOpen  = () => {
        return(alert("Clicked"))
    }
    
    return (
        <VerticalLayout className="courses-table standard-small-margin-top standard-rounded" style={{ textAlign: "left", borderCollapse: 'collapse'}}>
            <TableHeader headers={headers}/>
            <Tablebody steps={steps} stepOpen={stepOpen}/>
        </VerticalLayout>
    )
}
    const stepss = [
                        {
                            id_step: 1,
                            title: "Stap 1",
                            status: "completed",
                            description: "stap1",
                            courseCount: "1",
                            leads: "10"
                        },
                        {
                            id_step: 2,
                            title: "Stap 2",
                            status: "in_progress",
                            description: "stap2",
                            courseCount: "2",
                            leads: "15"
                        },
                        {
                            id_step: 3,
                            title: "Stap 3",
                            status: "not_started",
                            description: "stap3",
                            courseCount: "3",
                            leads: "30"
                        }
                        ];


export function CampagneTableComp({ steps = stepss , headers= [] }) {

    const stepOpen  = () => {
        return(alert("Clicked"))
    }
    
    return (
        <VerticalLayout className="courses-table standard-small-margin-top standard-rounded" style={{ textAlign: "left", borderCollapse: 'collapse'}}>
            {/* <TableHeader headers={headers}/> */}
            <Tablebody steps={steps} stepOpen={stepOpen}/>
        </VerticalLayout>
    )
}

const TableHeader = ({headers}) => {
    return (
            <div className="campagne-table-head">
                { headers.map((header,index) => {
                    return(<p style={{ width:(index == 0)&&"50%", alignItems: "center", textAlign:index == 0 ? "left" : "center", }} className="standard-padding semi-bold">{header}</p>)
                })}
            </div>
    )
}

const Tablebody = ({ steps, stepOpen }) => {
  return (
    <div className="courses-table-body">
      {steps.map(step => (
        <CampagneTableRow 
          key={step.id_step} 
          onClick={stepOpen} 
          step={step} 
        />
      ))}
    </div>
  );
};

const CampagneTableRow = ({ step = {}, onClick }) => {
  function getCourseStatus(course) {
    const progress = parseInt(course.progress, 10);
    const published = course.published;
    const active = course.active;

    const statusMap = [
      { check: () => published === 0, status: "notPublished" },
      { check: () => published === 2, status: "inactive" },
      { check: () => published === 1 && progress === 0, status: "published" },
      { check: () => published === 1 && progress > 0 && progress < 100, status: "inProgress" },
      { check: () => published === 1 && progress === 100 && active === 2, status: "finished" },
      { check: () => published === 1 && progress === 100, status: "published" }
    ];

    const found = statusMap.find(entry => entry.check());
    return found ? found.status : "unknown";
  }
//   const avatar = course.image_url || `https://ui-avatars.com/api/?name=${course.title}`
  return (
    <div data-testid={"course-table-row"} onClick={() => alert("clicked")} className="courses-table-row">
      <div className="courses-table-information">
        {/* <img src={avatar} alt={course.title} /> */}
        <div>
          <p className="course-info title">{step.title}</p>
          <p className="course-info description">{step.description}</p>
        </div>
      </div>
      {/* <div className="course-info center">
        {course.moduleCount * 3}m
      </div> */}
      <div className="course-info center">
        {step.courseCount}
      </div>
      <div className="course-info center">
        <CourseStatusLabel status={getCourseStatus(step)} />
      </div>
      <div className="course-info center">
         {step.leads}
      </div>
    </div>
  )
}